import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=bf45eedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf45eedc"]])

export default __exports__